module.exports = __webpack_public_path__ + "static/media/3.9390e7fc.jpg";